import { Controller } from "@hotwired/stimulus"

// Copy link and the device's own share sheet. Other platforms are plain links in the view.
export default class extends Controller {
  static targets = ["native", "status", "copy"]
  static values = { url: String, title: String }

  connect() {
    if (navigator.share) this.nativeTarget.hidden = false
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.statusTarget.textContent = "Link copied."
    } catch (error) {
      this.statusTarget.textContent = "Copy failed. Select the address bar and copy it."
    }
  }

  async native() {
    try {
      await navigator.share({ title: this.titleValue, url: this.urlValue })
    } catch (error) {
      // The user closed the share sheet: nothing to report.
    }
  }
}
